<template>
    <div class="question" v-if="questionIn">
        <div class="question-wrapper">
            <h2 class="question-title">{{ questionIn.question }}</h2>

            <b-form-group class="multiple-choice-answer" :label="$t('digital_studies.choose_answer')" v-slot="{ ariaDescribedby }"
                          :class="{'checked': correctAnswer}"
                          v-if="questionIn.answers.length > 1">
                <b-form-radio class="answer-option" v-model="selectedAnswer" :aria-describedby="ariaDescribedby"
                              v-for="answer of questionIn.answers"
                              :key="answer.id"
                              :class="[
                                        {'correct': correctAnswer && correctAnswer[0].id === answer.id},
                                        {'answer': selectedAnswer && selectedAnswer === answer.id}
                                        ]"
                              :value="answer.id">
                    {{ answer.answer }}
                </b-form-radio>
            </b-form-group>

            <div v-else class="answer">{{questionIn.answers}}</div>

            <b-button class=".btn-grade-check btn-skip-question" variant="primary" @click="resumeVideo">
                {{ correctAnswer ? ($t('digital_studies.go_further')) : ($t('digital_studies.skip')) }}
            </b-button>
            <b-button class=".btn-grade-check btn-check-answer" variant="primary" @click="checkAnswer" v-show="selectedAnswer">
                {{$t('digital_studies.check_answer')}}
            </b-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "design-2021-digistudies-video-question-overlay-component",
        props: {
            questionIn: {
                type: Object,
                default: null
            },
            correctAnswer: {
                type: Array,
                default: null
            }
        },

        data() {
            return {
                selectedAnswer: null,
            }
        },

        methods: {
            checkAnswer() {
                this.$emit('check-answer', this.selectedAnswer);
            },

            resumeVideo() {
                this.$emit('resume-video');
            }

        }
    }
</script>

<style scoped lang="scss">
    @media(min-width: map-get($grid-breakpoints, 'sm')) {
        .video-wrapper {
            position: relative;

            .question {
                display: flex;
                align-items: flex-start;
                justify-content: center;
                flex: 1 0 100%;
                flex-wrap: wrap;
                position: absolute;
                background-color: var(--bg-color);
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                opacity: 0.93;
                text-align: center;
                color: $white;
                padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'fifteen') 45px map-get($grid-gutter-spacing, 'ten');
            }

            .question-wrapper {
                position: relative;
                width: 100%;
            }

            .question-title {
                font-size: $base-font-size;
                font-weight: $font-weight-bold;
                margin-bottom: map-get($grid-gutter-spacing, 'twenty-one') ;
            }

            .multiple-choice-answer ::v-deep{
                flex: 1 0 100%;

                legend {
                    display: none;

                    & + div {
                        text-align: left;
                        width: fit-content;
                        margin: auto;
                    }
                }

                .answer-option {
                    &:not(:last-child) {
                        margin-bottom: map-get($grid-gutter-spacing, 'eight');
                    }
                }

                label {
                    font-size: $default-font-size;

                    &:after,
                    &:before {
                        top: 0;
                    }
                }

                .btn {
                    font-size: $default-font-size;
                }
            }

            .multiple-choice-answer.checked {
                .answer-option {

                    &.correct ::v-deep {
                        color: $primary;

                        label {
                            &:before,
                            &:after {
                                font-family: 'Font Awesome 5 Pro';
                                width: 1.25em;
                                font-size: $base-font-size;
                                border: none;
                                background-color: unset;
                            }

                            &:before {
                                content: '\f0c8';
                                font-size: 1.125rem;
                                color: $white
                            }

                            &:after {
                                content: '\f00c';
                                font-size: $base-font-size;
                                color: $primary;
                                top: 1px;
                            }
                        }
                    }

                    &.answer:not(.correct) ::v-deep {
                        color: $danger;

                        label {
                            &:before,
                            &:after {
                                font-family: 'Font Awesome 5 Pro';
                                width: 1.25em;
                                font-size: $base-font-size;
                                border: none;
                                background-color: unset;
                            }

                            &:before {
                                content: '\f0c8';
                                font-size: 1.125rem;
                                color: $white
                            }

                            &:after {
                                content: '\f00d';
                                font-size: $base-font-size;
                                color: $danger;
                                top: 1px;
                                left: -22px;
                            }
                        }
                    }

                }
            }

            .btn {
                font-size: $default-font-size;
            }

            .btn-check-answer {
                margin-left: $grid-gutter-width;
            }

        }
    }

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
        .video-wrapper {
            .question-wrapper {
                top: 15%;
            }

            .question-title {
                margin-bottom: map-get($grid-gutter-spacing, 'twenty-two');
            }
        }
    }
</style>
